<template>
	<rmp-master-account-access-application-base-step v-if="initialized" :title="tc('titles.selectBranch')">
		<v-form v-model="formValid" ref="form" :readonly="readonly || masterAccountAccessStore.createMasterAccountRequestOperationExecuting">
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col cols="12" class="mt-2">
						<rmp-alert width="100%">
							{{ tc("alerts.info.selectDivision") }}
						</rmp-alert>
					</v-col>
					<v-col cols="12"  class="mt-2">
						<rmp-divisions-autocomplete v-model="selectedDivisionId"
														   :items="divisionTree"
														   required>
						</rmp-divisions-autocomplete>
					</v-col>
					<v-col v-if="formattedDepartments.length" cols="12">
						<rmp-text type="body-medium-bold" class="mt-1" :color="colors.grey.darken2">
							{{ t("titles.departmentList", { branchName: selectedBranchName }) }}
						</rmp-text>
						
						<div class="mt-4">
							<rmp-text tag="span" type="body-medium" :color="colors.grey.darken1">
								{{ formattedDepartments.map((x) => x.shortName).join(", ") }}
							</rmp-text>
						</div>
					</v-col>
				</v-row>
			</v-container>
		</v-form>
	</rmp-master-account-access-application-base-step>
</template>

<script setup lang="ts">
import { useMasterAccountAccessSelectDivisionStepStore } from "@rmp/id/stores/masterAccountAccess/steps/selectBranch";
import { usePage } from "@rmp/core/composables/usePage";
import RmpMasterAccountAccessApplicationBaseStep
	from "@rmp/id/views/masterAccountAccess/steps/RmpMasterAccountAccessApplicationBaseStep.vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useMasterAccountAccessStore } from "@rmp/id/stores/masterAccountAccess";
import { useI18n } from "vue-i18n-composable";
import { useColors } from "@rmp/core/composables/useColors";
import RmpDivisionsAutocomplete from "@rmp/core/components/fields/RmpDivisionsAutocomplete.vue";
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpAlert from "@rmp/core/components/alerts/RmpAlert.vue";

export interface Props {
	readonly?: boolean;
}

defineProps<Props>();

const { colors } = useColors();

const { tc, t } = useI18n();

const useStore = useMasterAccountAccessSelectDivisionStepStore;
const masterAccountAccessStore = useMasterAccountAccessStore();
const store = useStore();

const {
	formValid,
	branches,
	departments,
	divisionTree,
	selectedDivisionId
} = storeToRefs(store);

const selectedBranchName = computed(() => branches.value.find(b => b.id === selectedDivisionId.value)?.shortName ?? "");

const formattedDepartments = computed(() => {
	return selectedDivisionId.value
		? departments.value.filter((department) => department.parentId === selectedDivisionId.value)
		: [];
});

const form = ref<any>(null);

const { initialized } = usePage({ useStore });
</script>
